export default "__VITE_ASSET__7726d034__"